import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    subscription: ''
  }),
  computed: {
    subTeamId (): string {
      return this.$store.direct.state.team.team.id
    }
  },
  watch: {
    subTeamId () {
      this.subscribeCastTemplates()
    }
  },
  created () {
    this.subscribeCastTemplates()
  },
  beforeDestroy () {
    this.unsubscribeCastTemplates()
  },
  methods: {
    subscribeCastTemplates () {
      if (this.subTeamId !== '' && this.subTeamId !== this.subscription) {
        this.unsubscribeCastTemplates()
        this.$store.direct.dispatch.castTemplates.subscribeTeamCastTemplates(this.subTeamId)
        this.subscription = this.subTeamId
      }
    },
    unsubscribeCastTemplates () {
      if (this.subscription !== '') {
        this.$store.direct.dispatch.castTemplates.unsubscribeTeamCastTemplates()
      }
    }
  }
})
